export default "__VITE_ASSET__07350ba5__"